export const CONTACT_PHONE_PATTERN = /^\+?[0-9]+$/;

export function normalizeContactPhone(value: string): string {
  const compact = value.replace(/\s/g, '');
  let out = '';
  for (const c of compact) {
    if (c === '+' && out.length === 0) {
      out += c;
    } else if (c >= '0' && c <= '9') {
      out += c;
    }
  }
  return out;
}

export function formatContactPhone(phone: string | null | undefined): string {
  if (phone == null || phone === '') return '';
  return normalizeContactPhone(phone);
}
